<template>
  <Popup class="more-info-popup" @close="close">
    <div class="banner" :style="bannerStyles">
      <div class="banner-filter" />
      <div class="banner-content">
        <p class="title">{{ evEvent.title }}</p>
        <p class="subtitle">{{ evEvent.type_text }} | {{ date }}</p>
        <p class="card-description">{{ evEvent.card_description }}</p>
      </div>

      <div class="buttons">
        <RegisterOrVideoButton :evEventOrCourse="evEvent" />
      </div>
    </div>

    <div class="description">
      <img class="overview-image" :src="$assets.image['overview.png']" alt="" />
      <p v-for="(paragraph, index) in outline" :key="`${paragraph}-${index}`" class="overview">
        {{ paragraph }}
      </p>
      <p v-for="(paragraph, index) in outcome" :key="`${paragraph}-${index}`" class="overview">
        {{ paragraph }}
      </p>
    </div>

    <div class="bio">
      <img
        class="photo"
        :src="evEvent.bio_image || $assets.image.default['bio_default_sq.svg']"
        :alt="`Photo of ${evEvent.bio_name}`"
      />
      <div class="info-container">
        <p class="bio-name">{{ evEvent.bio_name }}</p>
        <p class="bio-information">{{ evEvent.bio_information }}</p>

        <a
          v-if="evEvent.bio_linkedin"
          :href="linkedinAddress"
          target="_blank"
          rel="noopener noreferrer"
          class="linkedin"
        >
          <img class="icon" :src="$assets.svg['linkedin_icon']" alt="" />
          {{ evEvent.bio_linkedin }}
        </a>
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { computed } from 'vue';

import $assets from '@/assets';
import Popup from '@/components/event/Popup.vue';
import RegisterOrVideoButton from '@/components/event/RegisterOrVideoButton.vue';

const emit = defineEmits(['close']);
const props = defineProps({
  evEvent: {
    type: Object,
    default: () => ({}),
  },
});

const bannerStyles = computed(() => {
  return {
    backgroundImage: `url(${props.evEvent.info_banner})`,
  };
});

const date = computed(() => {
  if (!props.evEvent.start_date) return 'Coming Soon';

  const options = { dateStyle: 'long' };
  const startDate = props.evEvent.start_date.toLocaleString('en-CA', options);

  return startDate;
});

const outline = computed(() => {
  return props.evEvent.info_outline.split(/[\r\n]+/).map((line) => line);
});

const outcome = computed(() => {
  return (props.evEvent.info_outcome || '').split(/[\r\n]+/).map((line) => line);
});

const linkedinAddress = computed(() => {
  if (props.evEvent.bio_linkedin.startsWith('https')) {
    return props.evEvent.bio_linkedin;
  }
  return `https://${props.evEvent.bio_linkedin}`;
});

function close() {
  emit('close');
}
</script>

<style scoped>
.more-info-popup :deep(.popup-window) {
  height: 798px;
  width: 1000px;
}

.banner {
  position: relative;

  width: calc(100% - 70px);
  height: 290px;

  padding: 30px 35px;

  background: #d8d8d8;
  background-size: cover;
}

.banner-filter {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  opacity: 0.8;
  background-image: linear-gradient(180deg, #0f1925 9%, #030e3c 99%);
}

.banner-content {
  position: relative;
  width: 90%;
  max-width: 380px;

  font-family: Helvetica;
  color: #ffffff;
  font-size: 1em;
}

.banner-content > .title {
  font-size: 1.6em;
}

.banner-content > .title,
.banner-content > .subtitle {
  margin: 0;
}

.banner > .buttons {
  position: absolute;
  bottom: 50px;
  left: 35px;
}

.description {
  position: relative;
  width: calc(100% - 70px);
  min-height: 263px;
  padding: 20px 35px;
  padding-top: 263px;

  font-size: 1em;
  color: #31425c;
}

.description > .overview-image {
  position: absolute;
  top: 0%;
  right: 0%;
  height: 263px;
}

.description > .overview {
  width: 470px;
  max-width: 100%;
  margin-top: 0;
}

.bio {
  width: 100%;
  min-height: 245px;

  background: #defaff;

  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex-wrap: wrap; */
}

.bio > .photo {
  /* height: 245px; */
  width: 287px;
  max-width: 100%;
  max-height: 100%;

  display: block;
  background: white;

  object-fit: cover;
}

.bio > .info-container {
  width: calc(100% - 70px);
  max-width: 100%;
  padding: 0 35px;

  font-family: Helvetica;
  font-size: 1em;
  color: #333300;
}

.linkedin {
  /* width: var(--image-width); */
  width: 100%;
  margin: 1em 0;

  font-size: 1.1em;
  color: #053f89;
  text-decoration: none;
  word-break: break-all;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.linkedin > .icon {
  height: 2em;
  width: 2em;
}

@media only screen and (min-width: 601px) {
  .description {
    padding-top: 20px;
  }

  .bio {
    flex-direction: row;
  }

  .bio > .info-container {
    width: calc(100% - 287px);
  }
}
</style>
